import axios from "axios";
import { baseURL } from "../Constants";
import { PlayerMatch } from "../models/PlayerMatch";
import { SwingBreakdown } from "../models/SwingBreakdown";

const url = `${baseURL}/PlayerMatch`;

const roundPlayerStats = (player: PlayerMatch): PlayerMatch => {
    const roundedPlayer: PlayerMatch = {
        ...player,
        kills: Math.round(player.kills * 100) / 100,
        deaths: Math.round(player.deaths * 100) / 100,
        assists: Math.round(player.assists * 100) / 100,
        hs: Math.round(player.hs * 100) / 100,
        adr: Math.round(player.adr * 100) / 100,
        fk: Math.round(player.fk * 100) / 100,
        kast: Math.round(player.kast * 100) / 100,
        rating2: Math.round(player.rating2 * 100) / 100,
        rating21: player.rating21 ? Math.round(player.rating21 * 100) / 100 : undefined,
        // Round T-side stats if they exist (using camelCase to match API)
        tSideKills: player.tSideKills ? Math.round(player.tSideKills * 100) / 100 : undefined,
        tSideDeaths: player.tSideDeaths ? Math.round(player.tSideDeaths * 100) / 100 : undefined,
        tSideAssists: player.tSideAssists ? Math.round(player.tSideAssists * 100) / 100 : undefined,
        tSideHS: player.tSideHS ? Math.round(player.tSideHS * 100) / 100 : undefined,
        tSideADR: player.tSideADR ? Math.round(player.tSideADR * 100) / 100 : undefined,
        tSideKAST: player.tSideKAST ? Math.round(player.tSideKAST * 100) / 100 : undefined,
        tSideFK: player.tSideFK ? Math.round(player.tSideFK * 100) / 100 : undefined,
        tSideRating2: player.tSideRating2 ? Math.round(player.tSideRating2 * 100) / 100 : undefined,
        tSideRating21: player.tSideRating21 ? Math.round(player.tSideRating21 * 100) / 100 : undefined,
        // Round CT-side stats if they exist (using camelCase to match API)
        ctSideKills: player.ctSideKills ? Math.round(player.ctSideKills * 100) / 100 : undefined,
        ctSideDeaths: player.ctSideDeaths ? Math.round(player.ctSideDeaths * 100) / 100 : undefined,
        ctSideAssists: player.ctSideAssists ? Math.round(player.ctSideAssists * 100) / 100 : undefined,
        ctSideHS: player.ctSideHS ? Math.round(player.ctSideHS * 100) / 100 : undefined,
        ctSideADR: player.ctSideADR ? Math.round(player.ctSideADR * 100) / 100 : undefined,
        ctSideKAST: player.ctSideKAST ? Math.round(player.ctSideKAST * 100) / 100 : undefined,
        ctSideFK: player.ctSideFK ? Math.round(player.ctSideFK * 100) / 100 : undefined,
        ctSideRating2: player.ctSideRating2 ? Math.round(player.ctSideRating2 * 100) / 100 : undefined,
        ctSideRating21: player.ctSideRating21 ? Math.round(player.ctSideRating21 * 100) / 100 : undefined,
    };
    return roundedPlayer;
}


// The map's per-event swing breakdown, or null when it has none (parsed before it was stored).
export const getSwingBreakdown = async (gameId: string): Promise<SwingBreakdown | null> => {
    try {
        const response = await axios.get(`${url}/swing/${gameId}`);
        return response.data as SwingBreakdown;
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) return null;
        throw error;
    }
}

export const getPlayerMatchesByGameId = async (gameId: string): Promise<PlayerMatch[]> => {
    try {
        const response = await axios.get(`${url}/${gameId}`);
        const playerMatches = response.data as PlayerMatch[];
        return playerMatches.map(roundPlayerStats);
    }
    catch (error) {
        throw error;
    }
}

export const getPlayerMatchBySteamIdAndGameId = async (steamId: string, gameId: string): Promise<PlayerMatch> => {
    try {
        const response = await axios.get(`${url}/${gameId}/${steamId}`);
        const playerMatch = response.data as PlayerMatch;
        return roundPlayerStats(playerMatch);
    }
    catch (error) {
        throw error;
    }
}

